import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

type TradeChartSkeletonProps = {
  height: number
}

const RANGE_SIZE = 24

export const TradeChartSkeleton: React.FC<TradeChartSkeletonProps> = ({
  height,
}) => {
  return (
    <Root $height={height}>
      <TopToolbar>
        <TopToolbarLeft>
          <RangeGroup>
            <Skeleton width={RANGE_SIZE} height={RANGE_SIZE} />
            <Skeleton width={RANGE_SIZE} height={RANGE_SIZE} />
            <Skeleton width={RANGE_SIZE} height={RANGE_SIZE} />
            <Skeleton width={RANGE_SIZE} height={RANGE_SIZE} />
            <Skeleton width={RANGE_SIZE} height={RANGE_SIZE} />
            <Skeleton width={RANGE_SIZE} height={RANGE_SIZE} />
          </RangeGroup>
          <Divider />
          <Skeleton width={24} height={24} />
          <Divider />
          <Skeleton width={100} height={24} />
          <Divider />
          <Skeleton width={100} height={24} />
          <Divider />
          <Skeleton width={100} height={24} />
        </TopToolbarLeft>
        <Skeleton width={24} height={24} />
      </TopToolbar>
      <Main>
        <Toolbar>
          {Array.from({ length: 6 }).map((_, index) => (
            <Skeleton key={index} width={28} height={28} />
          ))}
          <PluginDivider />
          <Skeleton width={28} height={28} />
          <PluginDivider />
          <Skeleton width={28} height={28} />
        </Toolbar>
        <ChartGroup>
          <Top>
            <Chart>
              <Skeleton height="100%" />
            </Chart>
            <Values>
              {Array.from({ length: 16 }).map((_, index) => (
                <PriceSkeleton key={index} width="80%" height={8} />
              ))}
            </Values>
          </Top>
          <Bottom>
            {Array.from({ length: 6 }).map((_, index) => (
              <TimeSkeleton key={index} height={8} />
            ))}
          </Bottom>
        </ChartGroup>
      </Main>
    </Root>
  )
}

const Root = styled.div<{ $height: number }>`
  height: ${({ $height }) => $height}px;
  display: flex;
  flex-direction: column;
`

const RangeGroup = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 8px;
  width: 196px;
`

const Divider = styled.div`
  height: 22px;
  margin: auto 4px;
  width: 1px;
  background: var(--background-4);
`

const PluginDivider = styled.div`
  width: 28px;
  height: 1px;
  background: var(--background-4);
`

const TopToolbar = styled.div`
  width: 100%;
  height: 41px;
  border-bottom: 1px solid var(--background-4);
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 0px 9px;
  background: var(--appearance-1);
  color: var(--text-9);
`

const TopToolbarLeft = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`

const Main = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  height: 100%;

  border-bottom: 1px solid var(--background-4);
  overflow: hidden;
`

const Toolbar = styled.div`
  border-right: 1px solid var(--background-4);

  width: 48px;
  padding: 10px 0;

  gap: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Chart = styled.div`
  display: grid;
  padding: 10px;
  place-items: center;
`

const Values = styled.div`
  display: grid;
  border-left: 1px solid var(--background-4);

  padding: 12px 4px;

  display: flex;
  flex-direction: column;
  place-items: center;
  justify-content: space-between;
`

const ChartGroup = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
`

const Top = styled.div`
  display: grid;
  grid-template-columns: 1fr 72px;
`

const Bottom = styled.div`
  display: grid;
  padding: 10px;
  height: 40px;

  gap: 20px;
  grid-auto-flow: column;
  place-items: center;
  border-top: 1px solid var(--background-4);
`

const TimeSkeleton = styled(Skeleton)`
  > div {
    border-radius: 2px;
  }
`

const PriceSkeleton = styled(Skeleton)`
  > div {
    border-radius: 2px;
  }
`
